<template>
  <div>
    <mall-header></mall-header>
   <!-- <div class="guide-content " ></div> -->
    <div class="paysuc-div " >
          <div>
            <img class="paysuc-div-img"  src="../../static/images/大成功.png"/> 
            <span class="span-paysuc-css">订单支付成功</span> 
          </div>
          <div class="span-payinfo-css">
              <span v-if="orderData.type ==1" >支付方式：微信支付</span>
              <span v-if="orderData.type ==2" >支付方式：支付宝</span>
              <span style="    display: block;">支付金额：<label style="color: rgb(255, 98, 13);">￥{{orderData.totalAmount}}</label></span>
              <span style="    display: block;">支付时间：{{orderData.updateTime}}</span>
              <span style="    display: block;">订单编号：{{orderData.orderNo}}</span>
          </div>
          <div class="el-button-div">
            <el-button  class="el-button-ok" @click="openIndex">进入首页</el-button>
            <el-button class="el-button-cancel" @click="viewOrder">查看订单</el-button>
          </div>
    </div>                   
     <div style="clear: both;height: 210px;"></div> 
    <div style="left: 0px;bottom: 0px;width: 100%;z-index:1;text-align: center; padding: 20px 0;    color: #999999;font-size: 14px;">
      Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved
    </div>
  </div>
</template>
<script>
import http from '../api/public'
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import axios from 'axios'
  export default{
      data(){
          return{
            datas:{},
            discount:13.2,
            shipPrice:0,
            freightRisk:5,
            mdShow:false,
            orderData:[],
            selectType:0,
            payShow:true,
            oderId:''
           
          }
      },
      mounted() {
       this.orderId = this.$route.query.orderId;
       this.getOrderDetails();
      },
      methods: {
        //返回首页
        openIndex(){
          this.$router.push({ path:'/goodsList'});
        },
        //查看订单
        viewOrder(){
          this.$router.push({ path:'/orderDetails', query: {"orderId":this.orderId}});
        },
        getOrderDetails(){
           axios.get('/mallApi/mall/order/queryById?id='+this.orderId,{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
              res = res.data;
              if(res.success) {
                this.orderData = res.result;
                this.orderData.totalAmount  = http.changeUnitPrice(this.orderData.totalAmount);
              }else{
                if(res.code == 401) {
                  http.setLocalStorge();
                  this.$router.push({path: '/login'});
                }else{
                  this.$message(res.message);
                }
              }
            });
        }
      },
      components: {
        mallHeader,
        mallBread,
        mallFooter,
        http
      }
  }
</script>
<style >
.el-button-ok:hover{
  background: #428EFF;
  color: #FFFFFF;
}
.el-button-cancel:hover{  
  background: rgba(40, 126, 255, 0.1);
  border: 1px solid #287EFF!important;
  opacity: 0.6;
  color:#287EFF!important;
}

.el-button-ok:active{
  background: #126BF0;
  color: #FFFFFF;
}
.el-button-cancel:active{  
 background: rgba(40, 126, 255, 0.1);
 border: 1px solid #287EFF;
  opacity: 1;
}
.body-wrapper {
    padding-bottom: 100px;
}
  .paysuc-div{
    width: 1200px;
    min-width: 1200px;
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.02);
    margin: 0px auto;
    overflow: auto;
    margin-top: 20px;
    height: auto;
  }
  .paysuc-div-img{
    width: 80px;
    height: 80px;
     margin-left:560px;
     margin-top: 100px;
  }
  .span-paysuc-css{
    
    height: 29px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
    margin-left: 512px;
    margin-top: 20px;
    float: left;
  }
  .span-payinfo-css{
       float: left;
    margin-top: 78px;
    margin-left: -180px;
    height: 106px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;
    line-height: 30px;
    width: 250px;
  }
  .el-button-div{
      float: left;
      margin-top: 260px;
      margin-bottom: 100px;
  }
  .el-button-ok{
      font-size: 16px;
      font-family: "PingFang SC";
      font-weight: 500;
      color: rgb(255, 255, 255);
      width: 140px;
      height: 40px;
      background: rgb(40, 126, 255);
      border-radius: 4px;
      margin-left: -275px;
      text-align: center;
  }
  .el-button-cancel{
      font-size: 16px;
      font-family: "PingFang SC";
      font-weight: 500;
      color: rgb(51, 51, 51);
      width: 140px;
      height: 40px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(221, 221, 221);
      border-radius: 4px;
      margin-left: 20px !important;
      text-align: center;
  }
  
</style>



// WEBPACK FOOTER //
// paySuccess.vue?6f693194